// extracted by mini-css-extract-plugin
module.exports = {"container":"main-contact-list_container__24Oze","textDefault":"main-contact-list_textDefault__1Otuo","icon":"main-contact-list_icon__33CdU"};